<template>
  <div class="manual-google-cv-contents">
    <el-row>
      <el-col>
        <h2>成果データのダウンロード方法（PRESCO）</h2>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <h4>
          【１】<a href="https://presco.ai/" target="_blank" rel="noopener noreferrer">管理画面</a
          >にログインし、「レポート」→「成果一覧」をクリックします。
        </h4>
        <div class="mini-img">
          <img :src="`${rt}/img/manual/google-cv/no07/no29/01.png`" alt="" />
        </div>
        <h4>【２】検索期間を選択し「検索条件で絞り込む」をクリックします。</h4>
        <img :src="`${rt}/img/manual/google-cv/no07/no29/02.png`" alt="" />
        <h4>【４】CSVをダウンロードします。</h4>
        <img :src="`${rt}/img/manual/google-cv/no07/no29/03.png`" alt="" />

        <p>これで成果CSVのダウンロードは完了です。</p>
        「
        <router-link :to="`/manual/${tool.codeKebab}/07/14`"
          >ASPの成果データをアドタスカルにインポートする</router-link
        >」に進んでください。
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ManualGoogleCvContents",
  components: {
  },
  props: {},
  computed: {
    ...mapGetters(["rt", "tool", "tools"]),
  },
  methods: {},
};
</script>

<style lang="scss" scoped>

</style>
